<template src="./EditPersonal.template.html"></template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'
import { useEditPersonal } from '@/composables/usePersonals'
import { ArrowLeft, Save, AlertTriangle } from 'lucide-vue-next'

// Components
import PersonalsTopBar from '../components/personals/PersonalsTopBar.vue'
import PageHeader from '../components/ui/PageHeader.vue'
import LayoutMain from '../components/ui/LayoutMain.vue'
import Button from '../components/ui/Button.vue'
import Input from '../components/ui/Input.vue'
import Textarea from '../components/ui/Textarea.vue'
import Card from '../components/ui/Card.vue'
import Text from '../components/ui/Text.vue'
import Heading from '../components/ui/Heading.vue'
import LoadingSpinner from '../components/ui/LoadingSpinner.vue'
import ErrorDisplay from '../components/ui/ErrorDisplay.vue'

// Composables
const { t } = useI18n()
const route = useRoute()
const adId = route.params.id

const {
  form,
  errors,
  isLoading,
  error,
  loadAd,
  validateForm,
  submitForm,
  goBack
} = useEditPersonal(adId)

// Local state
const submitMessage = ref('')
const submitSuccess = ref(false)

// Computed
const titleCharacterCount = computed(() => form.value.title.length)
const bodyCharacterCount = computed(() => form.value.body.length)

// Methods
async function handleSubmit() {
  const result = await submitForm()
  submitMessage.value = result.message
  submitSuccess.value = result.success
  
  setTimeout(() => {
    submitMessage.value = ''
  }, 5000)
}

function handleCancel() {
  if (form.value.title.trim() || form.value.body.trim()) {
    if (confirm(t('personals.confirmDiscard'))) {
      goBack()
    }
  } else {
    goBack()
  }
}

// Lifecycle
onMounted(async () => {
  await loadAd()
})
</script>

<style scoped>
.edit-personal {
  min-height: 100vh;
}

.form-actions {
  position: sticky;
  bottom: 0;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-top: 1px solid var(--neutral-200);
  padding: 1rem;
  margin: 2rem -1rem -1rem -1rem;
}

.character-counter {
  color: var(--neutral-500);
}

.character-counter.warning {
  color: var(--amber-600);
}

.character-counter.danger {
  color: var(--red-600);
}

.success-message {
  background: var(--emerald-50);
  color: var(--emerald-700);
  padding: 0.75rem;
  border-radius: 0.5rem;
  border: 1px solid var(--emerald-200);
  margin-bottom: 1rem;
}

.error-message {
  background: var(--red-50);
  color: var(--red-700);
  padding: 0.75rem;
  border-radius: 0.5rem;
  border: 1px solid var(--red-200);
  margin-bottom: 1rem;
}

.info-box {
  background: var(--blue-50);
  border: 1px solid var(--blue-200);
  border-radius: 0.5rem;
  padding: 1rem;
}
</style>